import React from 'react';
import styles from './DateCeil.module.scss';
import classnames from 'classnames';
export type IProps = {
  date: string | number; // 日期
  content: string | number;
  disabled: boolean;
  selected: boolean;
  isToday: boolean;
  isNotice?: boolean;
  isTask?: boolean;
  onClick?: (date: string) => void;
}
const DateCeil: React.FC<IProps> = ({
  date,
  content,
  disabled,
  selected,
  isToday,
  isNotice,
  isTask
}) => {
  const dateCeilCls = classnames(styles.dateCeil, {
    [styles.disabled]: disabled,
    [styles.selected]: selected,
    [styles.isNotice]: isNotice,
    [styles.isTask]: isTask
  });
  return (
    <div
      className={dateCeilCls}
      data-id={date}
    >
      {isToday ? '今' : content}
    </div>
  );
};

export default DateCeil;
